import { BaseClass } from './base-class';
import { Civility } from '@enums/civility.enum';
import { BaseRepository } from '@interfaces/base-repository';
import { Client } from './client';

export class Contact extends BaseClass implements BaseRepository {
  client: Client;
  firstname: string;
  lastname: string;
  phone: string;
  gsm: string;
  email: string;
  fax: string;
  locality: string;
  postalCode: string;
  street: string;
  streetNumber: string;
  service: string;
  site: string;

  constructor()
  constructor(
    client: Client,
    firstname: string,
    lastname: string,
    phone: string,
    gsm: string,
    email: string,
    fax: string,
    locality: string,
    postalCode: string,
    street: string,
    streetNumber: string,
    service: string,
    site: string
  )
  constructor(
    client?: Client,
    firstname?: string,
    lastname?: string,
    phone?: string,
    gsm?: string,
    email?: string,
    fax?: string,
    locality?: string,
    postalCode?: string,
    street?: string,
    streetNumber?: string,
    service?: string,
    site?: string
  ) {
    super();
    this.client = client;
    this.firstname = this.trim(firstname);
    this.lastname = this.trim(lastname);
    this.phone = this.trim(phone).replace(' ', '').replace('/', '');
    this.gsm = this.trim(gsm).replace(' ', '').replace('/', '');
    this.email = this.trim(email).toLowerCase();
    this.fax = this.trim(fax);
    this.locality = this.trim(locality);
    this.street = this.trim(street);
    this.streetNumber = this.trim(streetNumber);
    this.postalCode = this.trim(postalCode);
    this.service = this.trim(service);
    this.site = this.trim(site);
  }

  static fromObject(object: Contact): Contact {

    return Object.assign(new Contact(), {
      ...object,
      client: object.client ? Client.fromObject(object.client) : null,
    }
    );
  }

  get display(): string {
    return `${this.firstname} ${this.lastname}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.firstname, this.lastname], value);
  }
}
